module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av431-ece704acdd95bf39c94b681a3f1042bc.jpg";